<template>
  <card title="Background Color" :element="element">
    <e-color :element="element"></e-color>
    <e-transition-group :element="element"></e-transition-group>
  </card>
</template>

<script>
// import Component from "../component_location"
import CSlider from "@/components/Core/CSlider.vue";
import VSwatches from "vue-swatches";
import Card from "./Card.vue";
import EName from "./EName.vue";
import EColor from "./EColor";
import ETransitionGroup from "./ETransitionGroup";
import { GetColorName } from 'hex-color-to-color-name';

export default {
  components: {
    CSlider,
    VSwatches,
    Card,
    EName,
    EColor,
    ETransitionGroup,
    GetColorName,
  },

  props: {
    element: {
      type: Object,
      default: () => {
        return { name: "" };
      },
    },
  },

   data() {
    return {
      open: true,
    };
  },
  watch: {
   element: {
      deep: true,
      handler() {
        this.element.name = GetColorName(this.element.backgroundColor) + " Background"; //-0" + this.element.rank;
        }
    }
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },
  },

  computed: {},

  mounted() {
  },
};
</script>

<style></style>
